import { Value } from 'platejs';

import { formatBlock } from 'features/Editor';

export const editorToHtml = (value: Value | undefined) => {
	if (!value) {
		return '';
	}

	let string = ``;

	value.forEach((item, index) => {
		string += formatBlock(item, index === value.length - 1);
	});

	return string;
};
